/** @jsx jsx */
import React, { useState } from 'react';
import { Text, jsx } from 'theme-ui';
import { TextF5 } from '../text-f5';
import { Stack } from '../grid';
import { useCallback } from 'react';

export const FeatureRow = ({ font, title, rtl, span }) => {
  const [hover, setHover] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const handleClick = useCallback(() => {
    setEnabled(!enabled);
    setHover(!enabled);
  }, [hover, enabled]);

  const active = hover || enabled;
  return (
    <Stack
      as="button"
      aria-label={title}
      tabIndex={0}
      aria-pressed={active}
      gap={[8]}
      sx={{
        position: 'relative',
        flex: 1,
        textAlign: 'left',
        color: 'text',
        backgroundColor: 'bg.1',
        pt: [5, 6],
        pb: [6, 7, 8],
        px: [6, 7, 8],
        transition: 'all 0.2s cubic-bezier(0.190, 1.000, 0.220, 1.000)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: enabled ? 'accent' : 'transparent',
      }}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={handleClick}
    >
      <div>
        {span.map((span) => (
          <FeatureSpan key={span._key} rtl={rtl} active={active} font={font} {...span} />
        ))}
      </div>
      <Text
        aria-hidden={true}
        variant="h6"
        as="h5"
        sx={{
          color: active ? 'txt.1' : 'txt.3',
          transition: 'color 0.2s cubic-bezier(0.190, 1.000, 0.220, 1.000)',
        }}
      >
        {title}
      </Text>
    </Stack>
  );
};

const FeatureSpan = ({ active, font, rtl, span, feature, script = { code: 'en' } }) => {
  // const features = feature.

  //   const keys = tester.features.find((feat) => feat._key === cur).feature.map(({ key }) => key);
  //   return [...res, ...keys];
  // }, [])
  // .map((f) => `"${f}" on`);

  return (
    <TextF5
      as="span"
      features={active ? feature : []}
      variant="f5_typeface_feature"
      font={font._id}
      lang={active ? script && script.code : ''}
      dir={rtl ? 'rtl' : 'ltr'}
      sx={{ direction: rtl ? 'rtl' : 'ltr', fontVariantLigatures: 'no-common-ligatures' }}
    >
      {span}
    </TextF5>
  );
};
